import { fishList, areaList, sizeList } from 'src/mock/mockData'

// The live API (stein.efishery.com) was sunset — serve static mock data by URL instead.
// POST /list (useAddFish) hits the `list` branch too: trigger() resolves but nothing persists.
const fetcher = (input: RequestInfo | URL, _init?: RequestInit): Promise<any> => {
    const url = input.toString()
    if (url.includes('option_area')) return Promise.resolve(areaList)
    if (url.includes('option_size')) return Promise.resolve(sizeList)
    if (url.includes('list')) return Promise.resolve(fishList)
    return Promise.resolve([])
}
const uppercaseFirstWord = (string: string) => string.replace(/\b[a-z]/g, letter => letter.toUpperCase())
const parseNumberFormatID = (number: number) => Intl.NumberFormat('id-ID').format(number)

type Overwrite<T, U> = Pick<T, Exclude<keyof T, keyof U>> & U

export type {
    Overwrite
}
export {
    fetcher,
    uppercaseFirstWord,
    parseNumberFormatID
}